import React from 'react'
import { ProfileIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ProfileIcon'
import { WorkIcon } from '@frontend/pole-ui/lib/components/Icon/svg/WorkIcon'
import type { ICategory } from './interfaces'
import { messages } from './messages'

export const initialCategories: ICategory[] = [
  {
    icon: <ProfileIcon />,
    text: messages.physicPerson,
  },
  {
    icon: <WorkIcon />,
    text: messages.legalEntity,
  },
]
